import './frequentlyAskedQuestions.scss';

// @vendors
import React, { useState } from 'react';
import classNames from 'classnames';

// @helpers
import { i18n } from 'core/i18n';
import { recordLinkV2 } from 'utilities/tagging';
import { IA_INVESTMENT_HOME_INTERACTIONS } from 'constants/tagging';



const FAQsTextKeys = [
    [
        { title: 'faqs_title1', description: 'faqs_description1' },
        { title: 'faqs_title2', description: 'faqs_description2' },
        { title: 'faqs_title3', description: 'faqs_description3' },
        {
            title: 'faqs_title4',
            description: 'faqs_description4',
            linkText: 'faqs_linkText4',
            linkUrl: 'faqs_linkUrl4',
        },
    ],
    [
        { title: 'faqs_title5', description: 'faqs_description5' },
        { title: 'faqs_title6', description: 'faqs_description6' },
        { title: 'faqs_title7', description: 'faqs_description7' },
        { title: 'faqs_title8', description: 'faqs_description8' },
    ],
];

const FrequentlyAskedQuestions = () => {
    const [itemOpened, setItemOpened] = useState('0-0');
    const { formatText, FormattedText } = i18n;

    return (
        <div className="brokerIA-FAQs__container">
            <div className="brokerIA-FAQs__header">{formatText('brokerIA-faqs_header')}</div>
            <div className="brokerIA-FAQs__list">
                {FAQsTextKeys.map((column, colIndex) => (
                    <div className={`column-${colIndex}`} key={colIndex}>
                        {column.map(
                            ({ title, description, linkText = '', linkUrl = '' }, rowIndex) => {
                                const currentItem = `${colIndex}-${rowIndex}`;
                                const currentlyOpen = itemOpened === currentItem;
                                const itemClassName = classNames('brokerIA-FAQs__item', {
                                    'brokerIA-FAQs__item--opened': currentlyOpen,
                                });
                                const arrowClassName = classNames('brokerIA-FAQs__icon', {
                                    'brokerIA-FAQs__icon--opened': currentlyOpen,
                                });

                                return (
                                    <div className={itemClassName} key={`${colIndex}-${rowIndex}`}>
                                        <div
                                            className="brokerIA-FAQs__title"
                                            onClick={() => {
                                                setItemOpened(currentlyOpen ? -1 : currentItem)
                                                recordLinkV2({
                                                    accionEvento: currentlyOpen ? 'close' : 'open',
                                                    categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
                                                    etiquetaEvento: formatText(`brokerIA-${title}`),
                                                });
                                            }}
                                        >
                                            <div>{formatText(`brokerIA-${title}`)}</div>
                                            <i className={arrowClassName} />
                                        </div>
                                        {currentlyOpen && (
                                            <div className="brokerIA-FAQs__description">
                                                <FormattedText value={`brokerIA-${description}`} />
                                                {linkText && linkUrl && (
                                                    <a
                                                        className="brokerIA-FAQs__link"
                                                        href={formatText(`brokerIA-${linkUrl}`)}
                                                        target="_blank"
                                                    >
                                                        {formatText(`brokerIA-${linkText}`)}
                                                    </a>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            }
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FrequentlyAskedQuestions;
